import React,{useState} from 'react'
import Navbar from '../Navbar/navbar.jsx';
import Footer from '../Footer/footer';
import './home.css';
import FooterDoodles from '../Footer/footerDoodles.jsx';
import HomePageApi from './homePageApi.jsx';

const Home=()=> {
 

  return (
    <>
    <div className=''>
    <Navbar/>
    <HomePageApi  />
    <FooterDoodles/>
    <Footer/>
    </div>
   
    
    </>
  )
}

export default Home;